import { useMemo } from 'react';

import { getResponsiveClassNames } from '../../../shared/helpers/getResponsiveClassNames';
import { IResponsiveClassNames } from '../../../shared/types/IResponsiveClassNames';
import { SCREEN_SIZES } from '../../../shared/types/SCREEN_SIZES';

import { GRID_CELL_SIZE } from './GRID_CELL_SIZE';
import styles from './GridCell.module.css';
import { IGridCellProps } from './IGridCellProps';

const responsiveOffsetClassNames: IResponsiveClassNames<GRID_CELL_SIZE> = {
    [SCREEN_SIZES.SMALL]: {
        [GRID_CELL_SIZE.COLUMN_1]: styles['sm-offset-1'],
        [GRID_CELL_SIZE.COLUMN_2]: styles['sm-offset-2'],
        [GRID_CELL_SIZE.COLUMN_3]: styles['sm-offset-3'],
        [GRID_CELL_SIZE.COLUMN_4]: styles['sm-offset-4'],
        [GRID_CELL_SIZE.COLUMN_5]: styles['sm-offset-5'],
        [GRID_CELL_SIZE.COLUMN_6]: styles['sm-offset-6'],
        [GRID_CELL_SIZE.COLUMN_7]: styles['sm-offset-7'],
        [GRID_CELL_SIZE.COLUMN_8]: styles['sm-offset-8'],
        [GRID_CELL_SIZE.COLUMN_9]: styles['sm-offset-9'],
        [GRID_CELL_SIZE.COLUMN_10]: styles['sm-offset-10'],
        [GRID_CELL_SIZE.COLUMN_11]: styles['sm-offset-11'],
        [GRID_CELL_SIZE.COLUMN_12]: styles['sm-offset-12'],
    },
    [SCREEN_SIZES.MEDIUM]: {
        [GRID_CELL_SIZE.COLUMN_1]: styles['md-offset-1'],
        [GRID_CELL_SIZE.COLUMN_2]: styles['md-offset-2'],
        [GRID_CELL_SIZE.COLUMN_3]: styles['md-offset-3'],
        [GRID_CELL_SIZE.COLUMN_4]: styles['md-offset-4'],
        [GRID_CELL_SIZE.COLUMN_5]: styles['md-offset-5'],
        [GRID_CELL_SIZE.COLUMN_6]: styles['md-offset-6'],
        [GRID_CELL_SIZE.COLUMN_7]: styles['md-offset-7'],
        [GRID_CELL_SIZE.COLUMN_8]: styles['md-offset-8'],
        [GRID_CELL_SIZE.COLUMN_9]: styles['md-offset-9'],
        [GRID_CELL_SIZE.COLUMN_10]: styles['md-offset-10'],
        [GRID_CELL_SIZE.COLUMN_11]: styles['md-offset-11'],
        [GRID_CELL_SIZE.COLUMN_12]: styles['md-offset-12'],
    },
    [SCREEN_SIZES.LARGE]: {
        [GRID_CELL_SIZE.COLUMN_1]: styles['lg-offset-1'],
        [GRID_CELL_SIZE.COLUMN_2]: styles['lg-offset-2'],
        [GRID_CELL_SIZE.COLUMN_3]: styles['lg-offset-3'],
        [GRID_CELL_SIZE.COLUMN_4]: styles['lg-offset-4'],
        [GRID_CELL_SIZE.COLUMN_5]: styles['lg-offset-5'],
        [GRID_CELL_SIZE.COLUMN_6]: styles['lg-offset-6'],
        [GRID_CELL_SIZE.COLUMN_7]: styles['lg-offset-7'],
        [GRID_CELL_SIZE.COLUMN_8]: styles['lg-offset-8'],
        [GRID_CELL_SIZE.COLUMN_9]: styles['lg-offset-9'],
        [GRID_CELL_SIZE.COLUMN_10]: styles['lg-offset-10'],
        [GRID_CELL_SIZE.COLUMN_11]: styles['lg-offset-11'],
        [GRID_CELL_SIZE.COLUMN_12]: styles['lg-offset-12'],
    },
};

export function useOffsetClassNames (props: IGridCellProps): string {
    const {
        smOffset,
        mdOffset,
        lgOffset,
    }: IGridCellProps = props;

    return useMemo<string>((): string => {
        return getResponsiveClassNames({
            sm: smOffset,
            md: mdOffset,
            lg: lgOffset,
        }, responsiveOffsetClassNames);
    }, [
        smOffset,
        mdOffset,
        lgOffset]);
}
